const SearchIcon = ({ color = 'currentColor' }) => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7.5" cy="7.5" r="6.5" stroke={color} strokeWidth="2" />
      <line
        x1="12.7071"
        y1="12.2929"
        x2="17.7071"
        y2="17.2929"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
};

export default SearchIcon;
